import React from "react";
import "./FeaturesGrid.css";
import { 
  CreditCard, Banknote, Receipt, Shield, Clock, CheckCircle, 
  Zap, Users, TrendingUp, Wallet, Building, HeadphonesIcon, 
  Award, Star, ThumbsUp 
} from "lucide-react";

const features = [
  { icon: CreditCard, title: "Credit Card Swiping", desc: "All major cards accepted" },
  { icon: Banknote, title: "Instant Cash", desc: "Money in 5 minutes" },
  { icon: Receipt, title: "Bill Payments", desc: "We pay your CC bills" },
  { icon: Shield, title: "100% Secure", desc: "Safe & encrypted transactions" },
  { icon: Clock, title: "24/7 Available", desc: "Anytime, anywhere service" },
  { icon: CheckCircle, title: "Verified Service", desc: "Trusted by thousands" },
  { icon: Zap, title: "Lightning Fast", desc: "No waiting, instant process" },
  { icon: Users, title: "10K+ Customers", desc: "Growing community" },
  { icon: TrendingUp, title: "Lowest Rates", desc: "Starting from just 1.79%" },
  { icon: Wallet, title: "All Banks", desc: "HDFC, SBI, ICICI & more" },
  { icon: Building, title: "Multiple Locations", desc: "5+ locations in Chennai" },
  { icon: HeadphonesIcon, title: "Dedicated Support", desc: "Always here to help" },
  { icon: Award, title: "Best in Chennai", desc: "Top-rated service" },
  { icon: Star, title: "Premium Quality", desc: "Royal treatment guaranteed" },
  { icon: ThumbsUp, title: "100% Satisfaction", desc: "Money-back guarantee" },
];

const FeaturesGrid = () => {
  return (
    <section id="services" className="features-section">
      <div className="features-container">
        
        <div className="features-header fade-in-up">
          <h2 className="features-title gold-gradient-text">Why Choose Us</h2>
          <p className="features-subtitle">
            15+ reasons why we're Chennai's most trusted credit card service
          </p>
        </div>

        <div className="features-grid">
          {features.map((f, i) => (
            <div 
              key={f.title} 
              className="feature-card fade-in-up"
              style={{ animationDelay: `${i * 0.05}s` }}
            >
              <div className="feature-icon-wrapper">
                <f.icon size={24} />
              </div>
              <h3 className="feature-card-title">{f.title}</h3>
              <p className="feature-card-desc">{f.desc}</p>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default FeaturesGrid;